import React from 'react';
import './App.scss';
import AppRoutes from './routes/AppRoutes';

const App: React.FC = () => {
  return (
    <div className="app">
      <AppRoutes />
    </div>
  );
};

export default App;
